var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-color-container"},[_c('color-picker',{attrs:{"label":"Fill Color","color":_vm.value},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }